<style scoped="scoped" lang="scss">
.indicator_summary {
  .info {
    background-color: #F7F8FA;
    height: 28px;
    display: flex;
    margin-bottom: 12px;
    align-items: center;
    justify-content: flex-end;
    color: #419FFF;
    font-size: 12px;
    font-family: 'Microsoft YaHei UI';
  }


  .side {
    margin-top: 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    // 左侧
    .left {
      display: flex;
      align-items: center;

      .icon {
        display: inline-block;
        width: 5px;
        height: 16px;
        //background: #419FFF;
      }

      .txt {
        display: inline-block;
        font-weight: 400;
        font-size: 16px;
        color: #303133;
        margin-left: 12px;
      }
    }

    // 右侧
    .right {
      display: flex;
      align-items: center;
    }
  }

  .table {
    width: calc(100% - 0px);
    margin-top: 12px;

  }

}
</style>
<template>
  <div class="indicator_summary">
    <yi_curd_table v-show="false" v-bind="$attrs" :name="$options.name" ref="yt"></yi_curd_table>
    <!--  信息-->
    <div class="info">
      <div class="info-item">
        {{$t('meiri09:00gengxinzuorishuju')}}
      </div>
    </div>
    <div>
      <!--  表单-->
      <el-form size="mini" :inline="true" :model="conditions" class="demo-form-inline">
        <el-form-item :label="$t('xuanzeriqi')">
          <yi_time_input :maxTime="365*24*3600*1000" type="datetimerange"
              :start.sync="conditions.summaryDateStart" :end.sync="conditions.summaryDateEnd">
          </yi_time_input>
        </el-form-item>
        <el-form-item :label="$t('suoshuzuzhi')">
          <yi_data_select :type="'organization'" :ids.sync="conditions.orgIdSelected"
              :idsPath.sync="conditions.orgId"></yi_data_select>
        </el-form-item>
        <el-form-item :label="$t('shebeimingcheng')">
          <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="conditions.equipmentIds">
          </yi_data_select>
        </el-form-item>
        <el-form-item>
          <el-button @click="getSummary" type="primary" plain="plain">
            {{$t('sousuo')}}
          </el-button>
          <el-button @click="reset">{{$t('chongzhi')}}
          </el-button>
          <yi_curd_expand_button></yi_curd_expand_button>
        </el-form-item>
      </el-form>
    </div>
    <!--  汇总明细-->
    <div class="side">
      <div class="left">
        <span class="icon"></span>
        <span class="txt"></span>
      </div>
      <div class="right">
<!--        <el-button size="mini" type="default" @click="showShowTableColumn('equipmentProduction')"><i-->
<!--            class="yicon yicon-config_column"></i>-->
<!--        </el-button>-->
      </div>
    </div>
    <!--  表格-->
    <div class="table">
      <el-table stripe max-height="1000" :fit="false" :data="kpi.tableData"
          size="mini" border style="width: 100%" v-loading="searchLoading"
          :header-cell-style="{background: '#F5F7FA',  color:'#606266','font-weight':'700', height:'48px', padding:'0px'}"
          @header-dragend="headerDragend" @sort-change="sortChange">
        <el-table-column v-for="(item, index) in kpiTableColumn" :key="index"
            :prop="item.prop" :sortable="item.sortable" :label="$t(item.label)" :width="item.width"
            :show-overflow-tooltip="true">
        </el-table-column>
      </el-table>
      <div style="float: right; margin-top:8px">
        <el-pagination class="fy" layout="total,prev, pager, next,sizes"
            :current-page="conditions.currentPage" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" @prev-click="handleCurrentChange"
            @next-click="handleCurrentChange" :total="parseInt(conditions.total)"
            :page-sizes="[10, 20, 100, 500]" :pagerCount="5" background>
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
export default {
  name: "web_report_equipment_capacity_statistics_device_kpi",
  props: {
    parentParams: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      searchLoading: false,
      activeName: 'statistics',
      conditions: {
        orgId: null,
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      kpi: {
        tableData: [],
        tableColumn: [{
          key: 0,
          prop: 'equipmentName',
          sortable: true,
          label: 'shebeimingcheng',
          width: 100,
        }, {
          key: 1,
          prop: 'orgName',
          sortable: true,
          label: 'suoshuzuzhi',
          width: 130,
        }, {
          key: 2,
          prop: 'shiftName',
          sortable: true,
          label: 'banci',
          // width: 100,
        }, {
          key: 3,
          prop: 'dataBtStr',
          sortable: true,
          label: 'tongjishijianqujian',
          width: 150,
        }, {
          key: 4,
          prop: 'oee',
          sortable: true,
          label: 'OEE',
          width: 100,
        },
          {
            key: 5,
            prop: 'startupRateStr',
            sortable: true,
            label: 'kaijilu',
            width: 100,
          },
          {
            key: 6,
            prop: 'runRateStr',
            sortable: true,
            label: 'jiadonglu',
            width: 100,
          }, {
            key: 7,
            prop: 'yield',
            sortable: true,
            label: 'liangpinlv',
            width: 100,
          },
          {
            key: 8,
            prop: 'runDuration',
            sortable: true,
            label: 'yunxingshijian(xiaoshi)',
            width: 150,
          },
          {
            key: 9,
            prop: 'idleDuration',
            sortable: true,
            label: 'kongxianshijian(xiaoshi)',
            width: 150,
          },
          {
            key: 10,
            prop: 'errorDuration',
            sortable: true,
            label: 'guzhangshijian(xiaoshi)',
            width: 150,
          },
          {
            key: 11,
            prop: 'shutdownDuration',
            sortable: true,
            label: 'lixianshijian(xiaoshi)',
            width: 150,
          },
          {
            key: 12,
            prop: 'quantitySum',
            sortable: true,
            label: 'baogongshuliang',
            width: 100,
          },
          {
            key: 13,
            prop: 'badQuantitySum',
            sortable: true,
            label: 'buliangpinshu',
            width: 100,
          },

        ],
        // currentEquipmentkpi: this.$t('shebeiKPI'),
        // currentDate: ''
      },
    }
  },

  watch: {
    parentParams: {
      handler(n) {
        if (n.orgId) {
          this.$set(this.conditions, 'orgIdSelected', n.orgId)
        }
        if (n.firstDate) {
          this.$set(this.conditions, 'summaryDateStart', (new Date(n.firstDate)).getTime())
          console.log('fffffffffffff', this.conditions)

        }
        if (n.lastDate) {
          this.$set(this.conditions, 'summaryDateEnd', (new Date(n.lastDate)).getTime())
        }
        setTimeout(() => {
          this.getSummary()
        }, 0)
      },
      immediate: false,
      deep: true
    }
  },
  created() {
	setTimeout(() => {
		this.conditions.orgIdSelected = this.store.state.organizations[0].id
	}, 300)
  },
  computed: {
    kpiTableColumn() {
      const column = this.kpi.tableColumn
      const name = 'equipment_capacity_statistics'
      let colwidths = {}
      if (window.localStorage.getItem("colwidth_" + name)) {
        try {
          colwidths = JSON.parse(window.localStorage.getItem("colwidth_" + name))
        } catch (e) {
          window.localStorage.removeItem("colwidth_" + name)
        }
      }
      if (column.length > 0) {
        for (const i in column) {
          if (colwidths[this.$t(column[i]['label'])] !== undefined) {
            this.$set(column[i], 'width', colwidths[this.$t(column[i]['label'])])
          }
        }
      }
      return column
    },
  },
  mounted() {
    // console.log('1111122ddd',this.$emit('orgId', this.orgId))
  },
  methods: {
    headerDragend(newWidth, oldWidth, column, event) {
      const name = 'equipment_capacity_' + this.activeName
      let colwidths = {}
      if (window.localStorage.getItem("colwidth_" + name)) {
        try {
          colwidths = JSON.parse(window.localStorage.getItem("colwidth_" + name))
        } catch (e) {
          window.localStorage.removeItem("colwidth_" + name)
        }
      }
      if (column.label == "" || column.label == null) {
        return
      }
      colwidths[column.label] = column.width
      window.localStorage.setItem("colwidth_" + name, JSON.stringify(colwidths))
    },
    //条数切换
    handleSizeChange(value) {
      this.conditions.pageSize = value;
      this.getSummary()
    },
    //分页
    handleCurrentChange(value) {
      this.conditions.currentPage = value;
      this.getSummary()
    },
    reset() {
      this.$set(this.conditions, 'equipmentId', null)
      this.$set(this.conditions, 'summaryDateStart', new Date(this.parentParams.firstDate).getTime())
      this.$set(this.conditions, 'summaryDateEnd', new Date(this.parentParams.lastDate).getTime())
      // this.$set(this.conditions, 'orgIdSelected', this.parentParams.orgId)
	  this.$set(this.conditions, 'orgIdSelected', '')
      // this.$set(this.conditions, 'orgId', this.parentParams.selectedOrgIds + '')
	  this.$set(this.conditions, 'orgId', '')
	  this.$nextTick(() => {
	  	this.conditions.orgIdSelected = this.store.state.organizations[0].id
	  	this.$nextTick(() => {
	  		this.getSummary()
	  	})
	  })
      
    },
    sortChange() {
    },

    // 排序
    sortProp(a, b) {
      return a.prop - b.prop
    },

    dateFormat(time) {
      const t = new Date(time)
      // 日期格式
      const format = 'Ymd'
      let year = t.getFullYear()
      // 由于 getMonth 返回值会比正常月份小 1
      let month = t.getMonth() + 1
      let day = t.getDate()
      let hours = t.getHours()
      let minutes = t.getMinutes()
      let seconds = t.getSeconds()
      month = month > 9 ? month : `0${month}`
      day = day > 9 ? day : `0${day}`
      hours = hours > 9 ? hours : `0${hours}`
      minutes = minutes > 9 ? minutes : `0${minutes}`
      seconds = seconds > 9 ? seconds : `0${seconds}`
      const hash = {
        'Y': year,
        'm': month,
        'd': day,
        'h': hours,
        'i': minutes,
        's': seconds
      }
      return format.replace(/\w/g, o => {
        return hash[o]
      })
    },
    getSummary(init) {
      if (init && !this.conditions.summaryDateStart) {
        return false
      }
      this.searchLoading = true;
      let requestParam = {
        ...this.conditions,
        pageSize: this.conditions.pageSize,
        pageNum: this.conditions.currentPage,
        orderBy: 'sort,priority asc'
      }
      console.log('requestParam', requestParam)
      delete requestParam.currentPage
      if (Array.isArray(requestParam['equipmentId']) && requestParam['equipmentId'].length > 0) {
        requestParam['equipmentId'] = requestParam['equipmentId'].join(',')
      }
      if (Array.isArray(requestParam['orgId']) && requestParam['orgId'].length > 0) {
        requestParam['orgId'] = requestParam['orgId'].join(',')
      }      console.log(444, requestParam)
      if (Array.isArray(requestParam['equipmentIds']) && requestParam['equipmentIds'].length > 0) {
        requestParam['equipmentIds'] = requestParam['equipmentIds'].join(',')
      }
      if (requestParam['summaryDateStart'] !== undefined && requestParam['summaryDateStart'] !== '') {
        // requestParam['summaryDateStart'] = this.dateFormat(requestParam['summaryDateStart'])
        requestParam['summaryDateStart'] = requestParam['summaryDateStart']
      }
      if (requestParam['summaryDateEnd'] !== undefined && requestParam['summaryDateEnd'] !== '') {
        // requestParam['summaryDateEnd'] = this.dateFormat(requestParam['summaryDateEnd'])
        requestParam['summaryDateEnd'] = requestParam['summaryDateEnd']
      }
      for (const i in requestParam) {
        if (requestParam[i] === '' || requestParam[i] === null || requestParam[i] === undefined) {
          delete requestParam[i]
        }
      }
      return this.http.get('/web/report/page/equipment_kpi?' + this.qs.stringify(requestParam)).then(response => {
        this.kpi.tableData = response.data.rows || []
        this.conditions.total = response.data.total
        for (let i = 0; i < this.kpi.tableData.length; i++) {
          if (this.kpi.tableData[i]['oee'] == null) {
            this.kpi.tableData[i]['oee'] =
                (((this.kpi.tableData[i]['startupRateStr']) * (this.kpi.tableData[i]['runRateStr']) *
                    (this.kpi.tableData[i]['yield'] == null ? '' : this.kpi.tableData[i]['yield'])) / 10000).toFixed(1) + '%'
          }
          this.kpi.tableData[i]['startupRateStr'] == undefined ? '' : this.kpi.tableData[i]['startupRateStr'] = (this.kpi.tableData[i][
              'startupRateStr'
              ]) + '%'
          this.kpi.tableData[i]['runRateStr'] == undefined ? '' : this.kpi.tableData[i]['runRateStr'] = (this.kpi.tableData[i][
              'runRateStr'
              ]) + '%'
          this.kpi.tableData[i]['yield'] == undefined ? '' : this.kpi.tableData[i]['yield'] = (this.kpi.tableData[i][
              'yield'
              ]) + '%'

        }
        this.searchLoading = false;
      }).catch(error => {
        this.$message.error(this.$t(error));
        this.searchLoading = false;
      })
    }
  }
}
</script>
